module.exports = __webpack_public_path__ + "static/media/fm-icons-Quote.2fe6c836.svg";